import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  textField: {
    '& fieldset': {
      border: 'none',
    },
  },
  sendIcon: {
    minWidth: 20,
    padding: 4,
  },
  selectedItem: {
    backgroundColor: `${theme.palette.primary.light} !important`,
  },
}))

export default styles
